import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import NotFoundPage from "../pages/not_found";
import EvaluatorEvalutionFormPage from "../pages/evaluator/evaluation_form";
import EvaluatorEvaluatorHistoryPage from "../pages/evaluator/evaluator_history";
import EvaluatorEvaluatorProfilePage from "../pages/evaluator/evaluator_profile";
import LoginPage from "../pages/back_office/login";
import UserManagementPage from "../pages/back_office/user-management";
import UserCreateUpdatePage from "../pages/back_office/user-management/create-update";
import DashboardPage from "../pages/back_office/dashboard";
import DashboardUsagePage from "../pages/back_office/dashboard/usage";
import EFManagementPage from "../pages/back_office/ef-management";
import EFCreateUpdatePage from "../pages/back_office/ef-management/create-update";
import AccountPage from "../pages/back_office/account";
import { WebProvider } from "../contexts";
import LocationManagementPage from "../pages/back_office/location-management";
import ActivityPage from "../pages/back_office/activity";
import ReportPage from "../pages/back_office/report";
import TopEvaluatorsPage from "../pages/back_office/report/top-evaluators";
import RatingSummaryPage from "../pages/back_office/report/rating-summary";

export default function CoreRouter() {
  //==============================
  const basePath = process.env.REACT_APP_BASE_PATH || "/";
  //==============================
  return (
    <WebProvider>
      <BrowserRouter basename={basePath}>
        <Routes>
          {/* ==================== */}
          <Route path="/" element={<NotFoundPage />} />
          <Route path="/evaluator/evaluation_form" element={<EvaluatorEvalutionFormPage />} />
          <Route path="/evaluator/evaluator_history" element={<EvaluatorEvaluatorHistoryPage />} />
          <Route path="/evaluator/evaluator_profile" element={<EvaluatorEvaluatorProfilePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/user-management/list-view" element={<UserManagementPage />} />
          <Route path="/user-management/create-update" element={<UserCreateUpdatePage />} />
          <Route path="/user-management/create-update/:id" element={<UserCreateUpdatePage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/dashboard/usage" element={<DashboardUsagePage />} />
          <Route path="/ef-management/list-view" element={<EFManagementPage />} />
          <Route path="/ef-management/create-update" element={<EFCreateUpdatePage />} />
          <Route path="/ef-management/create-update/:id" element={<EFCreateUpdatePage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="/location-management/list-view" element={<LocationManagementPage />} />
          <Route path="/activity/list-view" element={<ActivityPage />} />
          <Route path="/report" element={<Navigate to={`/report/evaluation-history`} replace />} />
          <Route path="/report/evaluation-history" element={<ReportPage />} />
          <Route path="/report/top-evaluators" element={<TopEvaluatorsPage />} />
          <Route path="/report/rating-summary" element={<RatingSummaryPage />} />
          {/* ==================== */}
          <Route path="" element={<Navigate to={`/`} />} />
          <Route path="*" element={<Navigate to={`/`} />} />
          {/* ==================== */}
        </Routes>
      </BrowserRouter>
    </WebProvider>
  );
}
